import { IconPropTypes } from '@/legacy/types';

const AddIcon = (props: IconPropTypes) => {
	const { width, height, className } = props;
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 24}
			height={height || 24}
			fill='none'
			viewBox='0 0 24 24'
			scale={1}
			className={className || ''}
		>
			<path
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.714}
				d='M12 2.25v19.5'
			/>
			<path
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.714}
				d='M2.25 11.94h19.5'
			/>
		</svg>
	);
};

export default AddIcon;
